import * as React from "react"

export const linkDecorator = (href: string, text: string, key: string) => (
  <a href={href} key={key} target="_blank">
    {text}
  </a>
)
